import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

function deleteAddressService(environmentVariables, user, addressId: string) {
  const options = {
    headers: {
      ...get(environmentVariables, 'UCA_VALIDATION_API_HEADERS_POST_V3'),
      'Content-Type': 'application/vnd.safeway.v2+json',
      Accept: 'application/vnd.safeway.v2+json',
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };

  return snsAxiosClient(options).delete(
    formatString(get(environmentVariables, 'SNS_DELETE_ADDRESS', 'delete_address'), {
      UUID: get(user, 'UUID'),
    }),
    { data: { addressId } },
  );
}

export default deleteAddressService;
